module.exports = __webpack_public_path__ + "static/media/D4.796e0ca0.png";